export default function DocumentIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="document-icon"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 16}
      height={height ? height : width ? width : 16}
      viewBox="-1 0 14 18"
    >
      <path
        fill="currentColor"
        d="M10.125 8.719v.984c0 .232-.19.422-.422.422H3.797a.423.423 0 0 1-.422-.422V8.72c0-.232.19-.422.422-.422h5.906c.232 0 .422.19.422.422Zm-.422 2.531H3.797a.423.423 0 0 0-.422.422v.984c0 .232.19.422.422.422h5.906c.232 0 .422-.19.422-.422v-.984a.423.423 0 0 0-.422-.422ZM13.5 4.637v11.675c0 .932-.756 1.688-1.688 1.688H1.688A1.688 1.688 0 0 1 0 16.312V1.688C0 .756.756 0 1.688 0h7.175c.446 0 .875.18 1.192.496l2.95 2.95c.316.312.495.745.495 1.191ZM9 1.825V4.5h2.675L9 1.825Zm2.813 14.487V6.188H8.155a.842.842 0 0 1-.844-.843V1.687H1.688v14.626h10.126Z"
      />
    </svg>
  );
}
